<script>
import ModalSubscriptionPlanComponent from "../../features/modals/ModalSubscriptionPlanComponent";
export default {
  name: "ModalSubscriptionPlanView",
  extends: ModalSubscriptionPlanComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Plan de Inscripción"
    width="30%"
    class="subscription-plan-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información del Plan</legend>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
          >
            <el-form-item
              label="Categoria"
              prop="type"
            >
              <el-select
                v-model="formData.type"
                clearable
                filterable
                placeholder="Seleccionar"
                value-key="id"
                size="small"
              >
                <el-option
                  v-for="item in types"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            text-align="center"
          >
            <el-form-item
              label="Cantidad de Pagos"
              prop="paymentQuantity"
            >
              <el-input-number
                v-model.number="formData.paymentQuantity"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            text-align="center"
          >
            <el-form-item
              label="Precio"
              prop="amount"
            >
              <el-input-number
                v-model="formData.amount"
                :precision="2"
                :step="0.1"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="16"
            :md="16"
            :lg="16"
            :xl="16"
          >
            <el-form-item
              label="Código"
              prop="code"
            >
              <el-input
                v-model="formData.code"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
          >
            <el-form-item
              label="Activo"
              prop="isActive"
              align="center"
            >
              <el-switch
                v-model="formData.isActive"
                style="display: block"
                active-color="#13ce66"
                inactive-text="No"
                active-text="Si"
                :inactive-value="false"
                :active-value="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
          >
            <el-form-item
              label="Nombre"
              prop="name"
            >
              <el-input
                v-model="formData.name"
                maxlength="70"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Descripción"
              prop="description"
            >
              <el-input
                v-model="formData.description"
                maxlength="155"
                size="small"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="onShowDueDate()"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Fecha de Vencimiento"
              prop="dueDate"
            >
              <el-date-picker
                v-model="formData.dueDate"
                type="date"
                size="small"
                value-format="YYYY-MM-DD"
                format="DD MMM YYYY"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>
